import { Select, Space } from "antd";
import { useState } from "react";
import { useGetBrands } from "@entities/brand";
import { useGetBriefs } from "@entities/brief/lib/hooks/useGetBriefs";
import { ColumnFilterWrapper } from "./ColumnFilterWrapper";

interface BriefBrandFilterProps {
  props: { confirm: () => void; close: () => void };
  title?: string;
  selectedBrandId?: string;
  selectedBriefId?: string;
  handlePropsChange: (props: { brandId?: string; briefId?: string }) => void;
  filterCount?: number;
}

export function BriefBrandFilter({
  props,
  title = "Brief Info",
  selectedBrandId,
  selectedBriefId,
  handlePropsChange,
  filterCount,
}: BriefBrandFilterProps) {
  const [brandId, setBrandId] = useState<string>(selectedBrandId || "");
  const [briefId, setBriefId] = useState<string>(selectedBriefId || "");

  const [brandSearch, setBrandSearch] = useState<string>("");
  const [briefSearch, setBriefSearch] = useState<string>("");

  const { brands, isFetching } = useGetBrands(50, 1, brandSearch);
  const { briefs, isFetching: isFetchingBriefs } = useGetBriefs({
    searchQuery: briefSearch,
    limit: 50,
    pageNo: 1,
  });

  const isFiltered = !!(brandId || briefId);
  const calculatedCount = (brandId ? 1 : 0) + (briefId ? 1 : 0);

  const handleApply = () => {
    handlePropsChange({
      brandId: brandId || undefined,
      briefId: briefId || undefined,
    });
    props.confirm();
  };

  const handleResetInternal = () => {
    setBrandId("");
    setBriefId("");
    handlePropsChange({ brandId: undefined, briefId: undefined });
    props.confirm();
  };

  return (
    <ColumnFilterWrapper
      title={title}
      filterCount={filterCount ?? calculatedCount}
      isFiltered={isFiltered}
      confirm={props.confirm}
      close={props.close}
      onApply={handleApply}
      onReset={handleResetInternal}
    >
      <Space direction="vertical" style={{ width: "100%" }} size={12}>
        <div>
          <p style={{ margin: "0 0 4px 0", fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em", color: "#9ba3b2" }}>
            Brand
          </p>
          <Select
            options={brands?.data?.map((brand) => ({
              label: brand.name,
              value: brand._id,
            }))}
            value={brandId}
            onChange={setBrandId}
            style={{ width: "100%" }}
            showSearch
            allowClear
            onSearch={setBrandSearch}
            filterOption={false}
            loading={isFetching}
            placeholder="Select Brand"
          />
        </div>
        <div>
          <p style={{ margin: "0 0 4px 0", fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em", color: "#9ba3b2" }}>
            Brief
          </p>
          <Select
            options={briefs?.map((brief) => ({
              label: brief.name,
              value: brief._id,
            }))}
            value={briefId}
            onChange={setBriefId}
            style={{ width: "100%" }}
            showSearch
            allowClear
            onSearch={setBriefSearch}
            filterOption={false}
            loading={isFetchingBriefs}
            placeholder="Select Brief"
          />
        </div>
      </Space>
    </ColumnFilterWrapper>
  );
}
